'use client';

import { MID_PAGE_CTA_EXPERIMENT_NAME } from 'lib/experiments';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
import ga4 from 'tracking/src/ga4';
import { retrieval } from 'utilities/src/experiments/utils/client-utils';
import { analytics } from 'utilities/src/experiments/client';

export default function ExperimentEvents() {
  const path = usePathname();

  useEffect(() => {
    const slug = path.substring(1, path.length - 1);
    const experimentClient = retrieval().fromCookie(slug);

    const analyticsInstance = analytics(experimentClient);

    analyticsInstance.loadGaInstance(ga4);
    analyticsInstance.dispatchEvents();

    analyticsInstance.handshake(
      `${process.env.NEXT_PUBLIC_BASE_PATH}/api/experiment-handshake/`,
      window.location.href,
      {
        width: window.innerWidth,
        height: window.innerHeight,
      },
    );

    const hasMidCtaExperiment = retrieval().byExperiment(experimentClient, MID_PAGE_CTA_EXPERIMENT_NAME);
    if (hasMidCtaExperiment) {
      ga4.event('ab_variant_assigned', {
        value: hasMidCtaExperiment.variation === 'Treatment' ? 'treatment' : 'control',
      });
    }
  }, [path]);

  return null;
}
